import Vue from "vue"
import i18n from "@/i18n"
import store from './../store'

Vue.filter( "i18n", label => i18n.t( label ) )
Vue.filter( "showDate", date => ( moment( date ).isValid() )? moment( date ).format( "DD-MM-YYYY" ) : i18n.t( 'date.invalid') )
Vue.filter( 'toMoney', function(current) {
    let event = store.getters.getCurrentEvent()
    return (Math.round(current * 100) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "_").replace( /\./, ',').replace("_",'.') + (parseInt(event.type_id) == 15 ? " $" : " €") 
})